
// export default function LogoComponent ({ style, imageUrl, outerStyle }) {

//     return (
//         <div style={outerStyle}>
//             <img src={imageUrl} alt="image" style={style}/>
//         </div>
//     )
// };

export default function ImageComponent({ style, imageUrl, url, outerStyle }) {

  return (
    <table
      role="presentation"
      width="100%"
      cellPadding="0"
      cellSpacing="0"
      style={{ width: outerStyle?.width || "100%", backgroundColor: outerStyle?.backgroundColor }}
    >
      <tr>
        <td align={outerStyle?.align} style={{ padding: style?.padding || "0" }}>
          <a href={url || "#"} style={{ textDecoration: "none" }}>
            <img
              src={imageUrl}
              alt="image"
              style={{
                display: "block",
                width: style?.width,
                backgroundColor: style?.backgroundColor,
                border: "0",
                borderRadius: style?.borderRadius
              }}
            />
          </a>
        </td>
      </tr>
    </table>
  );
}
